export const TRANSLATION_KEY = 'STATIC.PAGES.ANALYSIS_CHAT.USER_MCP_CONNECTIONS';

const USER_MCP_CONNECTIONS_BASE = 'interactive-service/user-mcp-connections';

export const USER_MCP_CONNECTIONS_PATHS = {
    LIST: USER_MCP_CONNECTIONS_BASE,
    start: provider => `${USER_MCP_CONNECTIONS_BASE}/${provider}/start`,
    connection: provider => `${USER_MCP_CONNECTIONS_BASE}/${provider}`,
};

export const RESULT_PARAM = 'user_mcp_connect_result';
export const ERROR_PARAM = 'user_mcp_connect_error';
export const USER_MCP_URL_PARAMS = [RESULT_PARAM, ERROR_PARAM];

export const CONNECT_RESULT_CONNECTED = 'connected';

export const CONNECT_ERROR_KEYS = {
    not_available: 'NOT_AVAILABLE',
    session_expired: 'SESSION_EXPIRED',
    authorization_not_completed: 'NOT_COMPLETED',
    state_expired: 'STATE_EXPIRED',
    exchange_failed: 'EXCHANGE_FAILED',
    unexpected: 'UNEXPECTED',
};
export const GENERIC_ERROR_KEY = 'FAILED';

export const toastKey = key => `${TRANSLATION_KEY}.TOASTS.${key}`;

export const connectErrorToastKey = code => toastKey(CONNECT_ERROR_KEYS[code] ?? GENERIC_ERROR_KEY);

export const TOAST_AUTO_CLOSE_MS = 6000;
